export default __webpack_public_path__ + "static/media/waihuo.8d581658.png";